import { h, Component } from 'preact';
import * as QRCode from 'qrcode';

class QrCodeDebug extends Component {
    constructor(props) {
        super(props);
        this.setRef = el => { this.host = el; };
    }

    componentDidMount() {
        this.renderQr();
    }

    componentDidUpdate() {
        this.renderQr();
    }

    renderQr() {
        const { value = 'test', size = 160 } = this.props;
        if (!this.host || !value) return;

        console.log('QrCodeDebug: Rendering QR for value:', value);

        // Use hardcoded colors for debugging
        const opts = {
            errorCorrectionLevel: 'H',
            margin: 1,
            color: {
                dark: '#000000',
                light: '#ffffff'
            }
        };

        console.log('QrCodeDebug: Options:', opts);

        // Try canvas first
        let canvas = this.host.querySelector('canvas');
        if (!canvas) {
            this.host.innerHTML = '';
            canvas = document.createElement('canvas');
            this.host.appendChild(canvas);
        }

        canvas.width = size;
        canvas.height = size;
        canvas.style.border = '1px solid red'; // Debug border

        QRCode.toCanvas(canvas, String(value), opts, (err) => {
            if (err) {
                console.error('QrCodeDebug: Canvas render failed:', err);

                // Fallback to SVG
                QRCode.toString(String(value), { ...opts, type: 'svg' }, (err, svg) => {
                    if (err) {
                        console.error('QrCodeDebug: SVG render also failed:', err);
                        this.host.innerHTML = `<p style="color: red;">QR generation failed: ${err.message}</p>`;
                    } else {
                        console.log('QrCodeDebug: SVG render success');
                        this.host.innerHTML = svg;
                        const svgEl = this.host.firstElementChild;
                        if (svgEl) {
                            svgEl.setAttribute('width', String(size));
                            svgEl.setAttribute('height', String(size));
                            svgEl.style.border = '1px solid blue'; // Debug border
                        }
                    }
                });
            } else {
                console.log('QrCodeDebug: Canvas render success');
            }
        });
    }

    render() {
        return (
            <div ref={this.setRef} style="display: inline-block; background: yellow; padding: 10px;" />
        );
    }
}

export default QrCodeDebug;